/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDirectMessageResponse } from './IDirectMessageResponse';
import {
    IDirectMessageResponseFromJSON,
    IDirectMessageResponseFromJSONTyped,
    IDirectMessageResponseToJSON,
    IDirectMessageResponseToJSONTyped,
} from './IDirectMessageResponse';

/**
 * 
 * @export
 * @interface SendDmMessageResponse
 */
export interface SendDmMessageResponse {
    /**
     * 
     * @type {IDirectMessageResponse}
     * @memberof SendDmMessageResponse
     */
    message: IDirectMessageResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SendDmMessageResponse
     */
    conversationCreated?: boolean;
}

/**
 * Check if a given object implements the SendDmMessageResponse interface.
 */
export function instanceOfSendDmMessageResponse(value: object): value is SendDmMessageResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SendDmMessageResponseFromJSON(json: any): SendDmMessageResponse {
    return SendDmMessageResponseFromJSONTyped(json, false);
}

export function SendDmMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendDmMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': IDirectMessageResponseFromJSON(json['message']),
        'conversationCreated': json['conversationCreated'] == null ? undefined : json['conversationCreated'],
    };
}

export function SendDmMessageResponseToJSON(json: any): SendDmMessageResponse {
    return SendDmMessageResponseToJSONTyped(json, false);
}

export function SendDmMessageResponseToJSONTyped(value?: SendDmMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': IDirectMessageResponseToJSON(value['message']),
        'conversationCreated': value['conversationCreated'],
    };
}

